import App from 'app/app.js';

function LtSoftMatchFormCtrl() {
  this.firstName = null;
  this.lastName = null;
  this.grade = null;

  this.getFirstName = function () {
    return this.firstName;
  };

  this.setFirstName = function (value) {
    this.firstName = value;
  };

  this.getLastName = function () {
    return this.lastName;
  };

  this.setLastName = function (value) {
    this.lastName = value;
  };

  this.getGrade = function () {
    return this.grade;
  };

  this.setGrade = function (value) {
    this.grade = value;
  };
}

App.controller('LtSoftMatchFormCtrl', [LtSoftMatchFormCtrl]);
